import { RenderDateInput, RenderSelectInput } from "app/common/renderInput";
import Tooltip from "rc-tooltip";
import { useState } from "react";
import { Button, Col, Form, InputGroup, Row } from "react-bootstrap";
import { FaArrowRight, FaEdit, FaInfoCircle } from "react-icons/fa";
import { MdDelete, MdDeleteForever } from "react-icons/md";
import countryData from "../countryCode.json";
const PaxCard = ({
  index,
  values,
  touched,
  errors,
  handleChange,
  handleBlur,
  tripType,
  arrayHelpers,
  array,
  setFieldValue,
  calculateSSRAmount,
}) => {
  const [country, setCountry] = useState(countryData);
  const PtList = [
    { value: "ADULT", label: "Adult" },
    { value: "CHILD", label: "Child" },
    { value: "INFANT", label: "Infant" },
  ];
  const tiList = [
    { value: "Mr", label: "Mr" },
    { value: "Mrs", label: "Mrs" },
    { value: "Ms", label: "Ms" },
    { value: "Master", label: "Master" },
  ];
  const refundableOption = [
    { value: 1, label: "Refundable" },
    { value: 2, label: "Partial Refundable" },
    { value: 0, label: "Non Refundable" },
  ];
  const cabinClassOption = [
    { value: "ECONOMY", label: "Economy" },
    { value: "PREMIUM ECONOMY", label: "Premium Economy" },
    { value: "BUSINESS", label: "Business" },
    { value: "PREMIUM BUSINESS", label: "Premium Business" },
    { value: "FIRST", label: "First" },
  ];
  ///////////////////Extra Baggage//////////////////////
  const [baggage, setBaggage] = useState(""); // Current baggage name
  const [amountBag, setAmountBag] = useState(Number(0).toFixed(2)); // Current amount value
  const [extraBags, setExtraBags] = useState([]); // List of baggage & amounts
  const [editIndexBag, setEditIndexBag] = useState(null); // Track which index is being edited

  // Add new or update existing baggage item
  const handleAddOrUpdateBag = () => {
    if (baggage.trim() && amountBag >= 0) {
      let updatedBags = [...extraBags];
      const baggageInfo = {
        code: baggage,
        amount: Number(amountBag).toFixed(2),
      };
      if (editIndexBag !== null) {
        // Update existing entry

        updatedBags[editIndexBag] = baggageInfo;
        setEditIndexBag(null); // Exit edit mode
      } else {
        // Add new entry
        updatedBags = [...extraBags, baggageInfo];
      }

      // Immediately set updated array into Formik field
      setFieldValue(`pax.return[${index}].extraBag`, updatedBags);

      // Update local state
      setExtraBags(updatedBags);

      // Clear input fields
      setBaggage("");
      setAmountBag(Number(0).toFixed(2));
    }
  };

  // Edit button - populate inputs with selected baggage
  const handleEditBag = (index) => {
    const bag = extraBags[index];
    setBaggage(bag.code);

    setAmountBag(Number(bag.amount).toFixed(2));
    setEditIndexBag(index); // Track which item is being edited
  };

  // Remove baggage item
  const handleRemoveBag = (index) => {
    const filteredBags = extraBags.filter((_, i) => i !== index);
    setExtraBags(filteredBags);
    if (editIndexBag === index) {
      setBaggage("");
      setAmountBag(Number(0).toFixed(2));
      setEditIndexBag(null);
    }
    setFieldValue(`pax.return[${index}].extraBag`, filteredBags);
  };

  //////////////////////Seat/////////////////////////////

  const [seat, setSeat] = useState(""); // Current seat name (e.g., Seat Number)
  const [seatAmount, setSeatAmount] = useState(Number(0).toFixed(2)); // Current seat amount
  const [extraSeats, setExtraSeats] = useState([]); // List of seats & amounts
  const [editIndexSeat, setEditIndexSeat] = useState(null); // Track which seat index is being edited

  // Add or update seat entry
  const handleAddOrUpdateSeat = () => {
    if (seat.trim() && seatAmount >= 0) {
      let updatedSeats = [...extraSeats];
      const seatInfo = {
        code: seat,
        amount: Number(seatAmount).toFixed(2),
      };

      if (editIndexSeat !== null) {
        // Update existing seat
        updatedSeats[editIndexSeat] = seatInfo;
        setEditIndexSeat(null); // Exit edit mode
      } else {
        // Add new seat
        updatedSeats = [...extraSeats, seatInfo];
      }

      // Update Formik field for pax return
      setFieldValue(`pax.return[${index}].seat`, updatedSeats);

      // Update local state
      setExtraSeats(updatedSeats);

      // Clear inputs
      setSeat("");
      setSeatAmount(Number(0).toFixed(2));
    }
  };

  // Edit seat button - populate inputs with selected seat
  const handleEditSeat = (index) => {
    const selectedSeat = extraSeats[index];
    setSeat(selectedSeat.code);
    setSeatAmount(Number(selectedSeat.amount).toFixed(2));
    setEditIndexSeat(index);
  };

  // Remove seat entry
  const handleRemoveSeat = (index) => {
    const filteredSeats = extraSeats.filter((_, i) => i !== index);
    setExtraSeats(filteredSeats);

    if (editIndexSeat === index) {
      setSeat("");
      setSeatAmount(Number(0).toFixed(2));
      setEditIndexSeat(null);
    }

    // Update Formik field after deletion
    setFieldValue(`pax.return[${index}].seat`, filteredSeats);
  };
  ///////////MEAl//////////////////////////
  // Food State Management
  const [food, setFood] = useState(""); // Current food name
  const [amountFood, setAmountFood] = useState(Number(0).toFixed(2)); // Current food amount
  const [extraFoods, setExtraFoods] = useState([]); // List of foods & amounts
  const [editIndexFood, setEditIndexFood] = useState(null); // Track which food is being edited

  // Add or Update Food Item
  const handleAddOrUpdateFood = () => {
    if (food.trim() && amountFood >= 0) {
      let updatedFoods = [...extraFoods];
      const foodInfo = {
        code: food,
        amount: Number(amountFood).toFixed(2),
      };
      if (editIndexFood !== null) {
        // Update existing food item
        updatedFoods[editIndexFood] = foodInfo;
        setEditIndexFood(null); // Exit edit mode
      } else {
        // Add new food item
        updatedFoods = [...extraFoods, foodInfo];
      }

      // Immediately set updated food list into Formik field
      setFieldValue(`pax.return[${index}].food`, updatedFoods);

      // Update local state
      setExtraFoods(updatedFoods);

      // Clear input fields
      setFood("");
      setAmountFood(Number(0).toFixed(2));
    }
  };

  // Edit Food Item
  const handleEditFood = (index) => {
    const foodItem = extraFoods[index];
    setFood(foodItem.code);
    setAmountFood(Number(foodItem.amount).toFixed(2));
    setEditIndexFood(index);
  };

  // Remove Food Item
  const handleRemoveFood = (index) => {
    const filteredFoods = extraFoods.filter((_, i) => i !== index);
    setExtraFoods(filteredFoods);

    // Update Formik field
    setFieldValue(`pax.return[${index}].food`, filteredFoods);

    // Clear edit mode if removing the currently edited item
    if (editIndexFood === index) {
      setFood("");
      setAmountFood(Number(0).toFixed(2));
      setEditIndexFood(null);
    }
  };
  return (
    <>
      {index > 0 && <hr />}
      <Row
        style={{
          //  backgroundColor: "#e4ffff"  ,
          marginBottom: 8,
        }}
      >
        <Col>
          <div style={{ fontSize: 15, fontWeight: "bold" }}>
            Passenger -{index + 1} (
            {values?.pax?.return[index]?.pt == null
              ? "Adult"
              : values?.pax?.return[index]?.pt}
            )
          </div>
        </Col>

        {/* disabled={index == array.length - 1 ? false : true} */}
        {index > 0 && (
          <Col xs="6">
            {/* {index == array.length - 1 && ( */}
            <div className="d-flex justify-content-end ">
              <Button
                variant="danger"
                type="button"
                onClick={() => {
                  arrayHelpers.remove(index);
                }}
              >
                <MdDelete color="white" size={20} />
              </Button>
            </div>
          </Col>
        )}
      </Row>
      <Row>
        <Col xs="12" md="6" lg={tripType == 2 || tripType == 3 ? "4" : "4"}>
          <RenderSelectInput
            type="text"
            name={`pax.return[${index}].refundable`}
            display="Refundable Or Not"
            value={values?.pax?.return[index]?.refundable || ""}
            items={refundableOption}
            onChange={handleChange}
          ></RenderSelectInput>
        </Col>
        <Col xs="12" md="6" lg={tripType == 2 || tripType == 3 ? "4" : "4"}>
          <RenderSelectInput
            type="text"
            name={`pax.return[${index}].cc`}
            display="Cabin Class"
            value={values?.pax?.return[index]?.cc || ""}
            items={cabinClassOption}
            onChange={handleChange}
            required
          ></RenderSelectInput>
        </Col>
        <Col xs="12" md="6" lg={tripType == 2 || tripType == 3 ? "4" : "4"}>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <label className="heading">
              Ticket No. <span className="text-danger">*</span>
            </label>

            <input
              className="form-control"
              type="text"
              placeholder="Ticket No."
              name={`pax.return[${index}].ticketNo`}
              value={values?.pax?.return[index]?.ticketNo || ""}
              onChange={handleChange}
            />
            {touched?.pax?.return &&
            errors?.pax?.return &&
            touched?.pax?.return[index]?.ticketNo &&
            errors?.pax?.return[index]?.ticketNo ? (
              <div className="error-label">
                {errors?.pax?.return[index]?.ticketNo}{" "}
              </div>
            ) : (
              ""
            )}
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col
          xs="12"
          md="6"
          lg={tripType == 2 || tripType == 3 ? "6" : "3"}
          className="mb-3"
        >
          <Form.Group controlId="formBasicEmail">
            <Form.Label className="heading">
              Pax Type<span className="text-danger">*</span>
            </Form.Label>
            <Row style={{ marginTop: -20 }}>
              <RenderSelectInput
                type="text"
                name={`pax.return[${index}].pt`}
                value={values?.pax?.return[index]?.pt || ""}
                onChange={handleChange}
                items={PtList}
                // required
              ></RenderSelectInput>
            </Row>
          </Form.Group>
        </Col>
        <Col
          xs="12"
          md="6"
          lg={tripType == 2 || tripType == 3 ? "6" : "3"}
          className="mb-3"
        >
          <Form.Group controlId="formBasicEmail">
            <Form.Label className="heading">
              Title<span className="text-danger">*</span>
            </Form.Label>
            <Row style={{ marginTop: -20 }}>
              <RenderSelectInput
                type="text"
                name={`pax.return[${index}].ti`}
                value={values?.pax?.return[index]?.ti || ""}
                onChange={handleChange}
                items={tiList}
              ></RenderSelectInput>
            </Row>
          </Form.Group>
        </Col>
        <Col
          xs="12"
          md="6"
          lg={tripType == 2 || tripType == 3 ? "6" : "3"}
          className="mb-3"
        >
          <Form.Group controlId="formBasicEmail">
            <Form.Label className="heading">
              First Name<span className="text-danger">*</span>
            </Form.Label>
            <input
              className="form-control"
              type="text"
              placeholder="First Name"
              name={`pax.return[${index}].fN`}
              value={values?.pax?.return[index]?.fN || ""}
              onChange={handleChange}
            />
            {touched?.pax?.return &&
            errors?.pax?.return &&
            touched?.pax?.return[index]?.fN &&
            errors?.pax?.return[index]?.fN ? (
              <div className="error-label">
                {errors?.pax?.return[index]?.fN}
              </div>
            ) : (
              ""
            )}
          </Form.Group>
        </Col>
        <Col
          xs="12"
          md="6"
          lg={tripType == 2 || tripType == 3 ? "6" : "3"}
          className="mb-3"
        >
          <Form.Group controlId="formBasicEmail">
            <Form.Label className="heading">
              Last Name<span className="text-danger">*</span>
            </Form.Label>
            <input
              className="form-control"
              type="text"
              placeholder="Last Name"
              name={`pax.return[${index}].lN`}
              value={values?.pax?.return[index]?.lN || ""}
              onChange={handleChange}
            />
            {touched?.pax?.return &&
            errors?.pax?.return &&
            touched?.pax?.return[index]?.lN &&
            errors?.pax?.return[index]?.lN ? (
              <div className="error-label">
                {errors?.pax?.return[index]?.lN}
              </div>
            ) : (
              ""
            )}
          </Form.Group>
        </Col>
      </Row>

      {values?.flightType == "International" && (
        <Row>
          <Col xs="12" md="6" lg={tripType == 2 || tripType == 3 ? "6" : "3"}>
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label className="heading">
                DOB <span className="text-danger">*</span>
              </Form.Label>
              <Row style={{ marginTop: -20 }}>
                <RenderDateInput
                  type="date"
                  name={`pax.return[${index}].dob`}
                  value={values?.pax?.return[index]?.dob || ""}
                  onChange={handleChange}
                ></RenderDateInput>
              </Row>
              {touched?.pax?.return &&
              errors?.pax?.return &&
              touched?.pax?.return[index]?.dob &&
              errors?.pax?.return[index]?.dob ? (
                <div className="error-label">
                  {errors?.pax?.return[index]?.dob}{" "}
                </div>
              ) : (
                ""
              )}
            </Form.Group>
          </Col>
          <Col xs="12" md="6" lg={tripType == 2 || tripType == 3 ? "6" : "3"}>
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label className="heading">Passport Number</Form.Label>

              <input
                className="form-control"
                type="text"
                placeholder="Passport Number"
                name={`pax.return[${index}].pNum`}
                value={values?.pax?.return[index]?.pNum || ""}
                onChange={handleChange}
              />
              {touched?.pax?.return &&
              errors?.pax?.return &&
              touched?.pax?.return[index]?.pNum &&
              errors?.pax?.return[index]?.pNum ? (
                <div className="error-label">
                  {errors?.pax?.return[index]?.pNum}{" "}
                </div>
              ) : (
                ""
              )}
            </Form.Group>
          </Col>

          <Col xs="12" md="6" lg={tripType == 2 || tripType == 3 ? "6" : "3"}>
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label className="heading">
                Passport Issue Date<span className="text-danger">*</span>{" "}
              </Form.Label>
              <Row style={{ marginTop: -20 }}>
                <RenderDateInput
                  type="date"
                  name={`pax.return[${index}].pid`}
                  value={values?.pax?.return[index]?.pid || ""}
                  onChange={handleChange}
                ></RenderDateInput>
              </Row>

              {touched?.pax?.return &&
              errors?.pax?.return &&
              touched?.pax?.return[index]?.pid &&
              errors?.pax?.return[index]?.pid ? (
                <div className="error-label">
                  {errors?.pax?.return[index]?.pid}{" "}
                </div>
              ) : (
                ""
              )}
            </Form.Group>
          </Col>
          <Col xs="12" md="6" lg={tripType == 2 || tripType == 3 ? "6" : "3"}>
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label className="heading">
                Passport Expiry Date<span className="text-danger">*</span>
              </Form.Label>
              <Row style={{ marginTop: -20 }}>
                <RenderDateInput
                  type="date"
                  name={`pax.return[${index}].eD`}
                  value={values?.pax?.return[index]?.eD || ""}
                  onChange={handleChange}
                ></RenderDateInput>
              </Row>

              {touched?.pax?.return &&
              errors?.pax?.return &&
              touched?.pax?.return[index]?.eD &&
              errors?.pax?.return[index]?.eD ? (
                <div className="error-label">
                  {errors?.pax?.return[index]?.eD}
                </div>
              ) : (
                ""
              )}
            </Form.Group>
          </Col>
        </Row>
      )}
      <Row>
        {values?.flightType == "International" && (
          <Col
            xs="12"
            md="6"
            lg={
              tripType == 2 || tripType == 3
                ? values?.flightType == "International"
                  ? "6"
                  : "12"
                : values?.flightType == "International"
                ? "3"
                : "4"
            }
          >
            <Form.Label className="heading">
              Passport Nationality {values?.pax?.return[index]?.pNat}
            </Form.Label>
            <select
              className="form-control"
              name={`pax.return[${index}].pNat`}
              value={values?.pax?.return[index]?.pNat || ""}
              onChange={(e) => {
                debugger;
                handleChange(e);
              }}
              onBlur={handleBlur}
            >
              {country?.map((h, i) => (
                <option key={i} value={h.name}>
                  {h.name} - {h.code}
                </option>
              ))}
            </select>
          </Col>
        )}

        <Col xs="12" md="6" lg={tripType == 2 || tripType == 3 ? "6" : "4"}>
          <Form.Group className="mb-3">
            <Form.Label className="heading">Cabin Baggage</Form.Label>
            <input
              type="text"
              className="form-control"
              placeholder="Cabin Baggage"
              name={`pax.return[${index}].cabinBag`}
              value={values?.pax?.return[index]?.cabinBag || ""}
              onChange={handleChange}
            />
            {touched?.pax?.return &&
            errors?.pax?.return &&
            touched?.pax?.return[index]?.cabinBag &&
            errors?.pax?.return[index]?.cabinBag ? (
              <div className="error-label">
                {errors.pax?.return[index]?.cabinBag}
              </div>
            ) : (
              ""
            )}
          </Form.Group>
        </Col>
        <Col xs="12" md="6" lg={tripType == 2 || tripType == 3 ? "6" : "4"}>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label className="heading">Checking Baggage</Form.Label>
            <input
              type="text"
              className="form-control"
              placeholder="Checking Baggage"
              name={`pax.return[${index}].checkingBag`}
              value={values?.pax?.return[index]?.checkingBag || ""}
              onChange={handleChange}
            />
            {touched?.pax?.return &&
            errors?.pax?.return &&
            touched?.pax?.return[index]?.checkingBag &&
            errors?.pax?.return[index]?.checkingBag ? (
              <div className="error-label">
                {errors?.pax?.return[index]?.checkingBag}{" "}
              </div>
            ) : (
              ""
            )}
          </Form.Group>
        </Col>
        {values?.pax?.return[index]?.pt != "INFANT" && (
          <>
            <Col
              xs="12"
              md="6"
              lg={
                tripType == 2 || tripType == 3
                  ? values?.flightType == "International"
                    ? "6"
                    : "12"
                  : values?.flightType == "International"
                  ? "3"
                  : "4"
              }
            >
              <Form.Group className="mb-3">
                <Form.Label className="heading">Seat & Amount</Form.Label>
                <InputGroup className="mb-3">
                  <input
                    className="form-control"
                    type="text"
                    placeholder="Seat Number"
                    value={seat}
                    onChange={(e) => setSeat(e.target.value)}
                  />
                  <input
                    className="form-control"
                    type="number"
                    placeholder="Amount"
                    value={seatAmount}
                    onChange={(e) => setSeatAmount(e.target.value)}
                  />
                  {extraSeats.length > 0 && (
                    <InputGroup.Text>
                      <Tooltip
                        placement="top"
                        overlay={
                          <div>
                            <h6 className="text-white">Seats</h6>

                            {extraSeats.map((item, index) => (
                              <Row key={index}>
                                <Col lg={1}>{index + 1}.</Col>
                                <Col lg={6}>
                                  {item.code} - {item.amount}
                                </Col>

                                <Col lg={1}>
                                  <div
                                    style={{ cursor: "pointer" }}
                                    onClick={() => handleEditSeat(index)}
                                    className="ms-2"
                                  >
                                    <FaEdit size={15} className="text-write" />
                                  </div>
                                </Col>
                                <Col lg={1}>
                                  <div
                                    style={{ cursor: "pointer" }}
                                    onClick={() => handleRemoveSeat(index)}
                                    className="ms-2"
                                  >
                                    <MdDeleteForever
                                      size={15}
                                      className="text-danger"
                                    />
                                  </div>
                                </Col>
                              </Row>
                            ))}
                          </div>
                        }
                      >
                        <FaInfoCircle />
                      </Tooltip>
                    </InputGroup.Text>
                  )}
                  <Button
                    variant="primary"
                    id="button-addon2"
                    onClick={() => {
                      handleAddOrUpdateSeat();
                      calculateSSRAmount(values?.pax?.return);
                    }}
                    disabled={
                      values?.flightLegs?.return?.length ===
                        extraSeats.length && editIndexSeat === null
                    }
                  >
                    <FaArrowRight />
                  </Button>
                </InputGroup>
              </Form.Group>
            </Col>
            <Col
              xs="12"
              md="6"
              lg={
                tripType == 2 || tripType == 3
                  ? values?.flightType == "International"
                    ? "6"
                    : "12"
                  : values?.flightType == "International"
                  ? "6"
                  : "6"
              }
            >
              <Form.Group className="mb-3">
                <Form.Label className="heading">Meal & Amount</Form.Label>
                <InputGroup className="mb-3">
                  <input
                    className="form-control"
                    type="text"
                    placeholder="Meal"
                    value={food}
                    onChange={(e) => setFood(e.target.value)}
                  />
                  <input
                    className="form-control"
                    type="number"
                    placeholder="Amount"
                    value={amountFood}
                    onChange={(e) => setAmountFood(e.target.value)}
                  />
                  {extraFoods.length > 0 && (
                    <InputGroup.Text>
                      <Tooltip
                        placement="top"
                        overlay={
                          <div>
                            <h6 className="text-white">Meals</h6>

                            {extraFoods.map((item, index) => (
                              <Row key={index}>
                                <Col lg={1}>{index + 1}.</Col>
                                <Col lg={6}>
                                  {item.code} - {item.amount}
                                </Col>

                                <Col lg={1}>
                                  <div
                                    style={{ cursor: "pointer" }}
                                    onClick={() => handleEditFood(index)}
                                    className="ms-2"
                                  >
                                    <FaEdit size={15} className="text-write" />
                                  </div>
                                </Col>
                                <Col lg={1}>
                                  <div
                                    style={{ cursor: "pointer" }}
                                    onClick={() => handleRemoveFood(index)}
                                    className="ms-2"
                                  >
                                    <MdDeleteForever
                                      size={15}
                                      className="text-danger"
                                    />
                                  </div>
                                </Col>
                              </Row>
                            ))}
                          </div>
                        }
                      >
                        <FaInfoCircle />
                      </Tooltip>
                    </InputGroup.Text>
                  )}
                  <Button
                    variant="primary"
                    id="button-addon2"
                    onClick={() => {
                      handleAddOrUpdateFood();
                      calculateSSRAmount(values?.pax?.return);
                    }}
                    disabled={
                      values?.flightLegs?.return?.length ===
                        extraFoods.length && editIndexFood === null
                    }
                  >
                    <FaArrowRight />
                  </Button>
                </InputGroup>
              </Form.Group>
            </Col>
            <Col
              xs="12"
              md="6"
              lg={
                tripType == 2 || tripType == 3
                  ? values?.flightType == "International"
                    ? "6"
                    : "12"
                  : values?.flightType == "International"
                  ? "6"
                  : "6"
              }
            >
              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label className="heading">
                  Extra Baggage & Amount
                </Form.Label>
                <InputGroup className="mb-3">
                  <input
                    className="form-control"
                    type="text"
                    value={baggage}
                    onChange={(e) => setBaggage(e.target.value)}
                    placeholder="Baggage"
                  />
                  <input
                    className="form-control"
                    type="number"
                    placeholder="Amount"
                    value={amountBag}
                    onChange={(e) => setAmountBag(e.target.value)}
                  />
                  {extraBags.length > 0 && (
                    <InputGroup.Text>
                      <Tooltip
                        placement="top"
                        overlay={
                          <div>
                            <h6 className="text-white">Extra Baggages</h6>

                            {extraBags.map((item, index) => (
                              <Row key={index}>
                                <Col lg={1}>{index + 1}.</Col>
                                <Col lg={6}>
                                  {item.code} - {item.amount}
                                </Col>

                                <Col lg={1}>
                                  <div
                                    style={{ cursor: "pointer" }}
                                    onClick={() => handleEditBag(index)}
                                    className="ms-2"
                                  >
                                    <FaEdit size={15} className="text-write" />
                                  </div>
                                </Col>
                                <Col lg={1}>
                                  <div
                                    style={{ cursor: "pointer" }}
                                    onClick={() => handleRemoveBag(index)}
                                    className="ms-2"
                                  >
                                    <MdDeleteForever
                                      size={15}
                                      className="text-danger"
                                    />
                                  </div>
                                </Col>
                              </Row>
                            ))}
                          </div>
                        }
                      >
                        <FaInfoCircle />
                      </Tooltip>
                    </InputGroup.Text>
                  )}
                  <Button
                    variant="primary"
                    id="button-addon2"
                    onClick={() => {
                      handleAddOrUpdateBag();
                      calculateSSRAmount(values?.pax?.return);
                    }}
                    disabled={
                      values?.flightLegs?.return?.length === extraBags.length &&
                      editIndexBag === null
                    }
                  >
                    <FaArrowRight />
                  </Button>
                </InputGroup>
              </Form.Group>
            </Col>
            <Col>
              <label>
                <input
                  className={`form-check-input border-primary`}
                  type="checkbox"
                  placeholder="Food"
                  name={`pax.return[${index}].Wheelchair`}
                  value={values.pax.return[index].Wheelchair || ""}
                  onChange={handleChange}
                />{" "}
                <span style={{ fontWeight: "bold" }}>Wheelchair</span>
              </label>
            </Col>
          </>
        )}
      </Row>
    </>
  );
};

export default PaxCard;
